export const SET_APOLLO_CLIENT = 'SET_APOLLO_CLIENT'
